import { useState } from 'react';
import { Check } from 'lucide-react';
import { C } from '../constants';

export default function PartyButton({ party, selected, onClick, localFont }) {
  const [pressed, setPressed] = useState(false);

  const transform  = pressed ? 'scale(0.93)' : `scale(${selected ? 0.95 : 1})`;
  const transition = pressed
    ? 'transform 60ms cubic-bezier(0.4, 0, 0.6, 1), box-shadow 60ms ease-out'
    : 'transform 420ms cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 280ms ease, border-color 220ms ease';

  const boxShadow = pressed
    ? `0 2px 6px ${party.color}55, inset 0 6px 14px rgba(0,0,0,0.28)`
    : selected
      ? `0 0 0 3px ${party.color}, 0 0 32px ${party.color}AA, inset 0 4px 12px rgba(0,0,0,0.25)`
      : `0 10px 30px ${party.color}66, 0 2px 0 rgba(255,255,255,0.06) inset`;

  return (
    <button
      onClick={onClick}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onTouchStart={() => setPressed(true)}
      onTouchEnd={() => setPressed(false)}
      onTouchCancel={() => setPressed(false)}
      className="relative w-full text-left"
      style={{
        backgroundColor: party.color,
        color:           C.white,
        padding:         '1.5rem 1.2rem 1.4rem',
        borderRadius:    20,
        border:          `2px solid ${selected ? 'rgba(255,255,255,0.5)' : 'transparent'}`,
        boxShadow,
        transform,
        transition,
        cursor:          'pointer',
        outline:         'none',
        fontFamily:      "'Poppins', sans-serif",
        overflow:        'hidden',
      }}
    >
      {/* gloss highlight */}
      <span style={{
        position:     'absolute',
        top:          0, left: 0, right: 0,
        height:       '45%',
        background:   'linear-gradient(to bottom, rgba(255,255,255,0.16), rgba(255,255,255,0))',
        pointerEvents:'none',
        borderRadius: '20px 20px 0 0',
      }} />

      <div style={{ fontSize: '1.65rem', fontWeight: 700, letterSpacing: '0.01em', lineHeight: 1.05, position: 'relative' }}>
        {party.en}
      </div>
      <div style={{
        fontSize:   '0.82rem',
        marginTop:  '0.45rem',
        opacity:    0.9,
        fontFamily: localFont || "'Noto Sans Tamil', sans-serif",
        lineHeight: 1.3,
        position:   'relative',
        minHeight:  '1.4em',
      }}>
        {party.local}
      </div>

      {selected && (
        <span style={{
          position:       'absolute',
          top:            12, right: 12,
          width:          28, height: 28,
          borderRadius:   '50%',
          background:     C.white,
          color:          party.color,
          display:        'flex',
          alignItems:     'center',
          justifyContent: 'center',
          boxShadow:      '0 4px 12px rgba(0,0,0,0.35)',
          animation:      'tnpoll-pop 320ms cubic-bezier(0.175, 0.885, 0.32, 1.275)',
        }}>
          <Check size={16} strokeWidth={3.5} />
        </span>
      )}
    </button>
  );
}
